module.exports = "/static/assets/576a1103506ec80bd274c7bc5f586a7e.png";